import type { SVGProps } from 'react';

export const TextAlignleftSFSymbolMedium = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 20.4978 17.2016"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="17.2016" opacity="0" width="20.4978" x="0" y="0" />{' '}
        <path
          d="M0.911323 17.1838L11.9529 17.1838C12.4644 17.1838 12.8722 16.7699 12.8722 16.2619C12.8722 15.7469 12.4662 15.332 11.9529 15.332L0.911323 15.332C0.399802 15.332 0 15.7521 0 16.2619C0 16.7664 0.40156 17.1838 0.911323 17.1838Z"
          fill="currentColor"
        />{' '}
        <path
          d="M0.911323 12.0764L19.2092 12.0764C19.7207 12.0764 20.1365 11.6625 20.1365 11.1545C20.1365 10.6314 19.7224 10.2246 19.2092 10.2246L0.911323 10.2246C0.399802 10.2246 0 10.635 0 11.1545C0 11.6572 0.40156 12.0764 0.911323 12.0764Z"
          fill="currentColor"
        />{' '}
        <path
          d="M0.911323 6.96718L11.9529 6.96718C12.4644 6.96718 12.8722 6.5453 12.8722 6.0373C12.8722 5.52402 12.4662 5.11543 11.9529 5.11543L0.911323 5.11543C0.399802 5.11543 0 5.52754 0 6.0373C0 6.54179 0.40156 6.96718 0.911323 6.96718Z"
          fill="currentColor"
        />{' '}
        <path
          d="M0.911323 1.85175L19.2092 1.85175C19.7207 1.85175 20.1365 1.43788 20.1365 0.929877C20.1365 0.414841 19.7224 0 19.2092 0L0.911323 0C0.399802 0 0 0.420114 0 0.929877C0 1.43437 0.40156 1.85175 0.911323 1.85175Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
